export default __webpack_public_path__ + "static/media/background-green-gradient.40c3fca2.png";